import { render, staticRenderFns } from "./TalentDevelopment.vue?vue&type=template&id=779f8600&"
import script from "./TalentDevelopment.vue?vue&type=script&lang=js&"
export * from "./TalentDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./TalentDevelopment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports